var exports = {
  "item": "x7f9a0e16--0cbbf8--item",
  "content": "x7f9a0e16--0cbbf8--content",
  "question": "x7f9a0e16--0cbbf8--question",
  "answer": "x7f9a0e16--0cbbf8--answer",
  "icon": "x7f9a0e16--0cbbf8--icon",
};

module.exports = exports;
